import request from '@webtrader/core/request';

const revertNotification = () => {
  return request.get('/api/notification/v1/revert');
};

export default revertNotification;
